import { useState } from 'react';

import { themes, Button } from '../buttons';
import { Content, Popup, PopupPlace } from './items.styled';

export const Items = (props) => {
  const { maxActive = 5, actions, setAction } = props;
  const [show, setShow] = useState(false);

  if (!actions || !actions.length) {
    return null;
  }

  const withPopup = maxActive && actions.length > maxActive;

  // const togglePopup = () => {
  //   setShow((show) => !show);
  // };

  const getItemsEl = () => {
    const out = [];
    const outPopup = [];

    actions.forEach((el, idx) => {
      const target = withPopup && idx > maxActive - 1 ? outPopup : out;

      const theme = el.isDanger ? themes.red : themes.blue;
      target.push(
        <Button key={idx} onClick={() => setAction(el)} theme={theme}>
          {el.title}
        </Button>
      );
    });

    return { itemsEl: out, popupEl: outPopup };
  };

  const { itemsEl, popupEl } = getItemsEl();
  const cl = show ? 'active' : '';

  return (
    <Content>
      {itemsEl}
      {withPopup && (
        <PopupPlace onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)}>
          <Button className={cl} theme={themes.gray}>
            ...
          </Button>
          {show && <Popup>{popupEl}</Popup>}
        </PopupPlace>
      )}
    </Content>
  );
};
